import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuardService } from './services';

import {
    LoginViewComponent,
    DashboardViewComponent
} from './views';

import {
    AppCalendarComponent,
    AppUsersComponent
} from './components';

const routes: Routes = [
    {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
    },
    { 
        path: 'dashboard', 
        component: DashboardViewComponent,
        canActivate: [ AuthGuardService ],
        children: [
            {
                path: '',
                redirectTo: 'reservations',
                pathMatch: 'full'
            },
            {
                path: 'reservations',
                component: AppCalendarComponent
            },
            {
                path: 'users',
                component: AppUsersComponent
            }]
    },
    {
        path: 'login',
        component: LoginViewComponent
    }
  ];


@NgModule({
    imports: [
        CommonModule,
        RouterModule.forRoot(routes, {useHash: true})
    ],
    exports: [
        RouterModule
    ]
})
export class AppRoutingModule {

}


// WEBPACK FOOTER //
// C:/Users/Willi/Source/Repos/Reservation01/scr/reservation.client/src/app/app.routing.ts